module.exports = __webpack_public_path__ + "img/75748.2f42d55b.svg";